module.exports = __webpack_public_path__ + "media/entities/1107-e2f7539e.png";